var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0V4.33038H13.5862C13.341 3.33137 13.069 2.61554 12.7701 2.18289C12.4713 1.74238 12.0613 1.39233 11.5402 1.13274C11.249 0.99115 10.7395 0.920354 10.0115 0.920354H8.85057V13.2625C8.85057 14.0806 8.89272 14.5919 8.97701 14.7965C9.06897 15.001 9.24138 15.1819 9.49425 15.3392C9.75479 15.4887 10.1073 15.5634 10.5517 15.5634H11.069V16H2.90805V15.5634H3.42529C3.87739 15.5634 4.24138 15.4808 4.51724 15.3156C4.71648 15.2055 4.87356 15.0167 4.98851 14.7493C5.0728 14.5605 5.11494 14.0649 5.11494 13.2625V0.920354H3.98851C2.9387 0.920354 2.17625 1.14848 1.70115 1.60472C1.03448 2.24189 0.613027 3.15044 0.436782 4.33038H0V0H14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT);
export default __webpack_public_path__ + "static/media/T.a8f1e44e013a3f0fa4adc27f0e927092.svg";
export { ForwardRef as ReactComponent };